import React from 'react';
import { oneOf } from 'prop-types';
import Back from './SVG/Back';

import './Icon.scss';
import DownArrow from './SVG/DownArrow';
import Next from './SVG/Next';

export const TYPES = {
  back: Back,
  next: Next,
  'down-arrow': DownArrow,
};
const Icon = ({ type }) => {
  const Component = TYPES[type] || null;
  return Component ? <Component /> : null;
};

Icon.propTypes = {
  back: oneOf(Object.keys(TYPES)),
};
export default Icon;
